export default "__VITE_ASSET__C9yrL5z0__"